<template>
  <base-container ref="container" style="height: 100%">
    <el-table
      ref="shift"
      border
      stripe
      :data="list"
      :header-cell-style="getCellStyle"
      size="mini"
      highlight-current-row
      @selection-change="selectionChange"
    >
      <el-table-column
       type="index"
        align="center"
        header-align="center"
        prop="id"
        width="40px"
      ></el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="name"
        label="班次"
        width="120px"
      >
        <template slot-scope="{ row }">
          <span v-text="row.name"></span><br />
          <span>({{ row.startPoint }}-{{ row.endPoint }})</span><br />
          <el-link type="primary" @click="configBatchSchedule(row)">
            批量设置
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        :prop="'week' + i"
        :label="getWeekLabel(i)"
        v-for="i in 7"
        :key="i"
      >
        <template slot-scope="{ row }">
          <div v-if="row['week' + i].length">
            <div>{{ row["week" + i][0].deptName }}</div>
            <el-row
              style="border-bottom: 0.5px #1989FA solid"
              type="flex"
              justify="space-between"
              v-for="period in row['week' + i]"
              :key="period.id"
            >
              <span>{{ period.startPoint }}-{{ period.endPoint }}</span>
              <span>{{ period.numCount }}</span>
            </el-row>
            <el-row type="flex" justify="space-between">
              <b>合计</b>
              <b>{{ summary(row["week" + i]) }}</b>
            </el-row>
          </div>
          <span v-else>--</span>
          <span
            style="position: absolute; top: 0; right: 0"
            class="el-icon-s-tools color-primary clickable"
            @click="configSchedule(row, i)"
          >
          </span>
          <span
            v-if="row['week' + i].length"
            style="position: absolute; bottom: 0; right: 0"
            class="el-icon-delete color-danger clickable"
            @click="delSchedule(row, i)"
          ></span>
        </template>
      </el-table-column>
      <template #append>
        <div style="padding: 5px 0 5px 5px">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini" icon="el-icon-plus">
              添加班次<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="shiftIds.indexOf(shift.id) >= 0"
                :command="shift.id"
                v-for="shift in shifts"
                :key="shift.id"
              >
                {{ shift.name }}({{ shift.startPoint }}-{{ shift.endPoint }})
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleDelCommand">
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              class="margin-h5"
            >
              删除班次<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="shiftIds.indexOf(shift.id) < 0"
                :command="shift.id"
                v-for="shift in shifts"
                :key="shift.id"
              >
                {{ shift.name }}({{ shift.startPoint }}-{{ shift.endPoint }})
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </el-table>
  </base-container>
</template>

<script>
import { getWeekLabel } from "@/util/util";

export default {
  props: {
    doctorId: String,
    rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    shifts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      list: [],
      selectItems: [],
    };
  },
  computed: {
    shiftIds() {
      return this.list.map((c) => c.id);
    },
  },
  watch: {
    rules: {
      immediate: true,
      handler: function () {
        let arr = [];
        this.shifts.forEach((c) => {
          let shiftRules = this.rules.filter((r) => r.shiftId == c.id);
          if (shiftRules && shiftRules.length) {
            let item = Object.assign({}, c);
            for (let index = 1; index <= 7; index++) {
              item["week" + index] = [];
            }
            shiftRules.forEach((s) => {
              item["week" + s.weekNo].push({
                deptName: s.deptName,
                startPoint: s.startPoint,
                endPoint: s.endPoint,
                numCount: s.numCount,
              });
            });
            arr.push(item);
          }
        });
        this.list = arr;
      },
    },
  },
  methods: {
    getWeekLabel,
    summary(periods) {
      let sum = 0;
      periods.forEach((c) => {
        sum += c.numCount;
      });
      return sum;
    },
    getCellStyle({ row, column }) {
      let obj = { color: "white" };
      if (!column.property || column.property == "shiftId") {
        obj.backgroundColor = "#67C23A";
      } else {
        obj.backgroundColor = "#1989FA";
      }
      return obj;
    },
    handleCommand(shiftId) {
      let shift = this.shifts.find((c) => c.id == shiftId);
      if (shift) {
        let row = Object.assign({}, shift);
        for (let index = 1; index <= 7; index++) {
          row["week" + index] = [];
        }
        this.list.push(row);
      }
    },
    selectionChange(arr) {
      this.selectItems = arr;
    },
    delSchedule(row, i) {
      this.$confirm("确认删除该排班规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delRuleAfter", {
          shiftId: row.id,
          weekNo: i,
        });
      });
    },
    handleDelCommand(shiftId) {
      this.$confirm("确认删除该班次排班规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delRuleAfter", {
          shiftId,
        });
      });
    },
    configSchedule(row, i) {
      this.$emit("configSchedule", {
        shiftId: row.id,
        weekNo: i,
      });
    },
    configBatchSchedule(row) {
      this.$emit("configSchedule", {
        shiftId: row.id,
        weekNo: "",
      });
    },
  },
};
</script>

<style scoped>
</style>